// based on the ISO 3166 list of Mexico subdivisions: https://en.wikipedia.org/wiki/ISO_3166-2:MX
export const mexicoStateOptions = [
  { ID: "AGU", name: "Aguascalientes" },
  { ID: "BCN", name: "Baja California" },
  { ID: "BCS", name: "Baja California Sur" },
  { ID: "CAM", name: "Campeche" },
  { ID: "CMX", name: "Ciudad de México" },
  { ID: "COA", name: "Coahuila de Zaragoza" },
  { ID: "COL", name: "Colima" },
  { ID: "CHP", name: "Chiapas" },
  { ID: "CHH", name: "Chihuahua" },
  { ID: "DUR", name: "Durango" },
  { ID: "GUA", name: "Guanajuato" },
  { ID: "GRO", name: "Guerrero" },
  { ID: "HID", name: "Hidalgo" },
  { ID: "JAL", name: "Jalisco" },
  { ID: "MEX", name: "México" },
  { ID: "MIC", name: "Michoacán de Ocampo" },
  { ID: "MOR", name: "Morelos" },
  { ID: "NAY", name: "Nayarit" },
  { ID: "NLE", name: "Nuevo León" },
  { ID: "OAX", name: "Oaxaca" },
  { ID: "PUE", name: "Puebla" },
  { ID: "QUE", name: "Querétaro" },
  { ID: "ROO", name: "Quintana Roo" },
  { ID: "SLP", name: "San Luis Potosí" },
  { ID: "SIN", name: "Sinaloa" },
  { ID: "SON", name: "Sonora" },
  { ID: "TAB", name: "Tabasco" },
  { ID: "TAM", name: "Tamaulipas" },
  { ID: "TLA", name: "Tlaxcala" },
  { ID: "VER", name: "Veracruz de Ignacio de la Llave" },
  { ID: "YUC", name: "Yucatán" },
  { ID: "ZAC", name: "Zacatecas" },
];
